import React from 'react';
import FinancialModelNav from './FinancialModelNav';

const FinancialModel = () => {
  return (
    <div>
      <FinancialModelNav />
    </div>
  );
};

export default FinancialModel;
